import type { ChatRoomResponseLastMessageBasicInfoAllOfTwoType } from './chatRoomResponseLastMessageBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type ChatRoomResponseLastMessageBasicInfoAllOfTwo = {
  content?: string;
  type?: ChatRoomResponseLastMessageBasicInfoAllOfTwoType;
};
